import { authenticationService } from "../../services";

const Permission = ({roles, children}) => {
    let currentUser=""
    if(!authenticationService.currentUserValue|| !authenticationService.currentUserValue.id){       
        currentUser={type:"7"}
    }
    else{
        currentUser = authenticationService.currentUserValue 
    }
    if(!roles || !roles.length || roles.length && roles.includes(currentUser.type)) {
        return children
    }

    return null
}

export default Permission;